import React from "react";
import { useSelector } from "react-redux";
import AreaGraph from "../../Common/Graphs/AreaGraph";
import { Constants } from "../../Common/Constants";
import { sumOfRecordCounts } from "../../../helper/utility";

const Weekly = () => {
  // const { workoutanalytics } = useSelector((store) => store.Reports);
  const workoutSessionSplit = useSelector((store) => store.WorkOutAnalyticsReportReducer.workoutSessionSplitMinutes.count);
 const sumOfWorkoutSessionSplit = sumOfRecordCounts(workoutSessionSplit);

  return (
    <div className="row mt-4">
      <div id="chart" className="col-md-4">
        <AreaGraph
          // data={workoutanalytics?.workoutSessionSplit}
          data={workoutSessionSplit}
          title={`${Constants.workoutSessionSplitInMins} ${sumOfWorkoutSessionSplit}`}
          format=""
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default Weekly;
